import { combineReducers } from '@reduxjs/toolkit';

import loader from './loader/loaderSlice';
import { versionApi } from './version/versionSlice';
import { pokemonApi } from './pokemon/pokemonSlice';
import { usergroupApi } from './usergroup/usergroupSlice';

const rootReducer = combineReducers({
    loader,
    [versionApi.reducerPath]: versionApi.reducer,
    [pokemonApi.reducerPath]: pokemonApi.reducer,
    [usergroupApi.reducerPath]: usergroupApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
